import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import tickwhite from "../../images/tick-white.svg";
import { currencyFormatter, getUserIdFromLocalStorage, replaceSpacesWithUnderscore } from '../../utils/helper';
import { getAllAddress, handleCommonAddAddressForUser, handleCommonDeleteAddressForUser, handleCommonEditAddressForUser } from '../../utils/actions/allactions';
import { toast } from 'react-toastify';
import { downloadQuotationPdf } from '../../api/customer/quotation/commonQuotationApi';
import AddressModal from '../CommanAddressModal/AddressModal';
import { Modal as AntModal } from "antd";
import { LucidLoader } from '../Icons';
import { useInstance } from '../../context/instance.context';
import { addBillingAddress, deleteBillingAddress, getBillingAddressById, getUserBillingAddressByUserId, updateBillingAddress } from '../../api/customer/masters/commonMastersApi';
import GenericAddressComponent from '../GenericAddressComponent/GenericAddressComponent';
import PDFModalViewer from '../PDFViewerModal/PDFModalViewer';

const DownloadQuotationModal = ({
    show,
    setShow,
    selectedQuote,
    selectedShipMethod = 1
}) => {


    const [selectedShippingMethodForDownloadQuotation, setSelectShippingMethodForDownloadQuotation] = useState(1);
    useEffect(() => {
        setSelectShippingMethodForDownloadQuotation(selectedShipMethod);
    }, [selectedShipMethod])
    const [addressValues, setAddressValues] = useState({});
    const [billingAddressValue, setBillingAddressValues] = useState([]);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState("");
    const token = localStorage.getItem("Token");
    const [showGenericAddressModal, setGenericAddressModal] = useState(false);
    const [editBillingAddressId, setEditBillingAddressId] = useState('');
    const [reload, setReload] = useState(false);
    const [pdfModalInfo, setPdfModalInfo] = useState({
        show: false,
        fileName: '',
        pdfUrl: ''
    });

    const [isQuoteDownloading, setIsQuoteDownloading] = useState(false);

    const { organizationName } = useInstance();

    const addNewHandler = () => {
        setShowAddressModal(true);
    };
    const addNewBillingAddress = () => {
        setEditBillingAddressId(null);
        setGenericAddressModal(true);
    };
    useEffect(() => {
        if (!show) return;
        (async () => {
            getUserBillingAddressByUserId(getUserIdFromLocalStorage()).then((res) => {
                if (res.success) {
                    const firstAddress = res.billingAddress[0];
                    if (firstAddress?._id) {
                        setAddressValues((pre) => {
                            return { ...pre, billingAddress: firstAddress?._id };
                        });
                    };

                    setBillingAddressValues(res.billingAddress);
                }
            }).catch(Error);

        })()


    }, [reload, show]);


    useEffect(() => {
        if (!show) return;
        (async () => {
            try {

                const fetchedAddress = await getAllAddress(token);
                console.log("Fetched Address :", fetchedAddress);
                const localUserAddresses = [];
                fetchedAddress?.data?.map((address) => {
                    if (address?.userId == selectedQuote?.userId?._id) {
                        localUserAddresses.push(address);
                    }
                });
                const firstUserAddress = localUserAddresses[0];
                if (firstUserAddress?._id) {
                    setAddressValues({
                        ...addressValues, address: [...localUserAddresses], shippingAddress: firstUserAddress._id,
                        addressline1: firstUserAddress.addressLineOne,
                        addressline2: firstUserAddress.addressLineTwo,
                        city: firstUserAddress.city,
                        country: firstUserAddress.country,
                        state: firstUserAddress.state,
                        zipCode: firstUserAddress.postalCode,
                        firstName: firstUserAddress.firstName,
                        lastName: firstUserAddress.lastName || '',
                    });
                }
                else {
                    setAddressValues({
                        ...addressValues, address: [...localUserAddresses],
                    });
                }

            } catch (error) {
                console.log("Error :", error);
                // toast.error("Unable To Fetch Address ");
            }
        })()

    }, [show]);


    let handleDownload = async () => {
        if (!addressValues.shippingAddress) {
            toast.error(
                "Please select a valid shipping address to download quotation."
            );
            return;
        }
        if (!addressValues.billingAddress) {
            toast.error(
                "Please select a valid billing address to download quotation."
            );
            return;
        }
        if (selectedShippingMethodForDownloadQuotation == 1 && !selectedQuote.price1) {
            toast.error("Please select a valid shipping price to download quotation.");
            return;
        }
        if (selectedShippingMethodForDownloadQuotation == 2 && !selectedQuote.price2) {
            toast.error("Please select a valid shipping price to download quotation.");
            return;
        }
        if (selectedShippingMethodForDownloadQuotation == 3 && !selectedQuote.price3) {
            toast.error("Please select a valid shipping price to download quotation.");
            return;
        }

        let data = {
            quoteId: selectedQuote?._id,
            selectedShipMethod: selectedShippingMethodForDownloadQuotation,
            shippingAddress: addressValues.shippingAddress,
            billingAddress: addressValues.billingAddress,
            RefId: selectedQuote?.RefId,
            price: selectedShippingMethodForDownloadQuotation == 1 ? selectedQuote?.price1 : selectedShippingMethodForDownloadQuotation == 2 ? selectedQuote?.price2 : selectedQuote?.price3
        };

        // setShow(false);
        setIsQuoteDownloading(true);
        try {
            let response = await downloadQuotationPdf(data);

            const signedUrl = response?.data?.signedUrl;
            let lastDataOnPdf =
                selectedShippingMethodForDownloadQuotation == 1
                    ? "Rapid"
                    : selectedShippingMethodForDownloadQuotation == 2
                        ? "Standard"
                        : "Economy";

            if (signedUrl) {
                setPdfModalInfo({
                    show: true,
                    fileName: `${replaceSpacesWithUnderscore(organizationName)}_Quote_${selectedQuote?.RefId}_V${selectedQuote.version}_${lastDataOnPdf}.pdf`,
                    pdfUrl: signedUrl
                });
            }


        } catch (error) {
            console.log("Error In Quote Download :", error);
            toast.error("We are currently unable to download the quotation. Please feel free to use the comment for further assistance.");
        } finally {
            setIsQuoteDownloading(false);
            setShow(false);
        }
    };
    const handleAddressOnEdit = async (newFormData, index) => {
        let allAddresses = addressValues.address ? addressValues.address : [];
        let address = allAddresses[index];
        address = { ...address, ...newFormData };
        try {
            const response = await handleCommonEditAddressForUser(token, address);
            if (response.status) {
                allAddresses[index] = response.data;
                let addressValueData = {};
                if (addressValues.shippingAddress == response.data._id) {
                    addressValueData = {
                        addressline1: response.data.addressLineOne,
                        addressline2: response.data.addressLineTwo,
                        city: response.data.city,
                        country: response.data.country,
                        firstName: response.data.firstName,
                        lastName: response.data.lastName,
                        state: response.data.state,
                        zipCode: response.data.postalCode,
                    };
                }
                setAddressValues({
                    ...addressValues,
                    ...addressValueData,
                    address: allAddresses,
                });
                setShow(true);
            }
        } catch (error) {
            toast.error(error);
        }
    };
    const handledAddAddress = async (addressData) => {
        let data = {
            userId: selectedQuote.userId._id,
            addressData,
        };
        try {
            const response = await handleCommonAddAddressForUser(token, data);
            if (response.status) {
                let localAllUserAddress = addressValues?.address
                    ? [...addressValues.address]
                    : [];
                localAllUserAddress.push(response.data);
                setAddressValues({ ...addressValues, address: localAllUserAddress });
                toast.success("Address added succesfully");
                setShow(true);
            }
        } catch (error) {
            toast.error("Unable to add address");
        }
    };
    const editHandler = (index) => {


        setShowAddressModal(true);
        setIsEdit(true);
        setEditId(index);
        setShow(false);
    };

    const deleteData = async (i) => {
        try {
            if (i > -1) {
                setShow(false);
                const confirm = await new Promise((resolve) => {
                    AntModal.confirm({
                        title: 'Confirmation',
                        content: 'Are you sure?',
                        okText: 'Yes',
                        cancelText: 'No',
                        onOk: () => resolve(true),
                        onCancel: () => resolve(false),
                    });
                });
                if (!confirm) return;
                const addressToDelete = addressValues.address[i];
                let localAllAddress = addressValues?.address
                    ? [...addressValues.address]
                    : [];

                const addressDeleteResponse = await handleCommonDeleteAddressForUser(
                    token,
                    addressToDelete._id
                );
                if (addressDeleteResponse.status) {
                    localAllAddress.splice(i, 1);
                    setAddressValues({ ...addressValues, address: localAllAddress });
                    setShow(true);
                }
            }
        } catch (error) {

            toast.error("Delete data");
        }
    };
    const addBillingAddressFunction = async (data) => {
        try {
            const response = await addBillingAddress({ ...data, userId: selectedQuote.userId._id });
            if (response.success) {
                toast.success("Billing address added successfully");
                setGenericAddressModal(false);
                setReload((pre) => !pre);

            };

        } catch (error) {
            console.log("Error :", error);
            throw new Error('unable to add billing address');
        }


    };

    const getBillingAddressByid = async (id) => {
        try {
            const data = await getBillingAddressById(id);
            console.log("Data :", data);
            if (data.success) {
                return data?.billingAddress || null;
            }
        } catch (error) {

        }
    };
    const billingAddressUpdateFunction = async (id, data) => {
        try {
            const response = await updateBillingAddress(id, data);
            if (response.success) {
                toast.success("Billing address added successfully");
                setGenericAddressModal(false);
                setReload((pre) => !pre);
            };
        }
        catch (error) {
            throw new Error('unable to update billing address');
        }

    };
    const deleteBilllingAddress = async (id) => {
        try {
            if (id) {
                const response = await deleteBillingAddress(id);
                if (response.success) {
                    toast.success("Billing address added successfully");
                    setReload((pre) => !pre);

                }

            }


        } catch (error) {
            console.log("Error in profile  211 on " +
                moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
                error
            );
        }

    }
    const handleEditBillingAddress = (id) => {
        console.log("Id :", id);
        setEditBillingAddressId(id);
        setGenericAddressModal(true);
    }


    return (
        <div >
            <AddressModal
                addressModal={showAddressModal}
                setShowAddressModal={setShowAddressModal}
                recentAddress={addressValues?.address}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                id={editId}
                values={addressValues}
                handledAddAddress={handledAddAddress}
                handleAddressOnEdit={handleAddressOnEdit}
                userId={selectedQuote?.userId?._id}
            />
            <GenericAddressComponent
                show={showGenericAddressModal}
                setShow={setGenericAddressModal}
                type='billing'
                editAddressId={editBillingAddressId}
                userId={selectedQuote?.userId?._id}
                onAddFunction={addBillingAddressFunction}
                getAddressById={getBillingAddressByid}
                onUpdateFunction={billingAddressUpdateFunction}


            />
            <PDFModalViewer
                show={pdfModalInfo.show}
                handleClose={() => {
                    setPdfModalInfo({
                        show: false,
                        fileName: '',
                        pdfUrl: ''

                    })
                }}
                pdfUrl={pdfModalInfo.pdfUrl}
                fileName={pdfModalInfo.fileName}
            />

            <Modal
                size="sm"
                dialogClassName="d-flex align-items-center justify-content-center custom-modal-view-order2"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={() => setShow(false)}
                className='download-quote-modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title
                        className='sub-header'
                    >
                        Download quotation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="price-tabs">
                        {selectedQuote?.price1 > 0 ?

                            <div className={selectedQuote && selectedShippingMethodForDownloadQuotation == 1 ? "box-pr pr-checked " : "box-pr"}
                                onClick={() => {
                                    setSelectShippingMethodForDownloadQuotation(1);
                                }
                                } >
                                <label className="btn box-in !h-16 flex items-center justify-center">
                                    {/* {selectedShippingMethodForDownloadQuotation == 1 ? <span className="triangle-0">
                                        {" "}
                                        <img src={tickwhite} />
                                    </span> : null} */}
                                    <span className="price-sp relative z-10">
                                        {selectedQuote?.price1
                                            ? currencyFormatter(
                                                (
                                                    (selectedQuote?.price1 || 0) +
                                                    (selectedQuote?.shippingCharge1 || 0) + (selectedQuote.orderCertificationsCost || 0)
                                                ).toFixed(2)
                                            )
                                            : 0}
                                    </span>
                                    <span className="vld-bx">
                                        {selectedQuote?.leadTime1 + selectedQuote?.shippingDays1} Business days
                                    </span>
                                </label>
                            </div>
                            : <></>}

                        {selectedQuote?.price2 > 0 ? (
                            <div className={selectedQuote && selectedShippingMethodForDownloadQuotation == 2 ? "box-pr pr-checked " : "box-pr"}
                                onClick={() => {
                                    setSelectShippingMethodForDownloadQuotation(2);
                                }
                                } >
                                <label className="btn box-in !h-16 flex items-center justify-center">
                                    {/* {selectedShippingMethodForDownloadQuotation == 2 ? <span className="triangle-0">
                                        {" "}
                                        <img src={tickwhite} />
                                    </span> : null} */}
                                    <span className="price-sp relative z-10 ">
                                        {selectedQuote?.price2
                                            ? currencyFormatter(
                                                (
                                                    (selectedQuote?.price2 || 0) +
                                                    (selectedQuote?.shippingCharge2 || 0) + (selectedQuote.orderCertificationsCost || 0)
                                                ).toFixed(2)
                                            )
                                            : 0}
                                    </span>
                                    <span className="vld-bx">
                                        {selectedQuote?.leadTime2 + selectedQuote?.shippingDays2} Business days
                                    </span>
                                </label>
                            </div>
                        ) : (
                            <></>
                        )}
                        {selectedQuote?.price3 > 0 ? (
                            <div className={selectedQuote && selectedShippingMethodForDownloadQuotation == 3 ? "box-pr pr-checked " : "box-pr"}
                                onClick={() => {
                                    setSelectShippingMethodForDownloadQuotation(3);
                                }
                                } >
                                <label className="btn box-in !h-16  flex items-center justify-center">
                                    {/* {selectedShippingMethodForDownloadQuotation == 3 ? <span className="triangle-0">
                                        {" "}
                                        <img src={tickwhite} />
                                    </span> : null} */}
                                    <span className="price-sp relative z-10">
                                        {selectedQuote?.price3
                                            ? currencyFormatter(
                                                (
                                                    (selectedQuote?.price3 || 0) +
                                                    (selectedQuote?.shippingCharge3 || 0) + (selectedQuote.orderCertificationsCost || 0)
                                                ).toFixed(2)
                                            )
                                            : 0}
                                    </span>
                                    <span className="vld-bx">
                                        {selectedQuote?.leadTime3 + selectedQuote?.shippingDays3} Business days
                                    </span>
                                </label>
                            </div>
                        ) : (
                            <></>
                        )}



                    </div>
                    <div className=" mt-4 grid grid-cols-2 gap-x-2 ">
                        <div>
                            <h6 className="my-2">Select shipping address  </h6>
                            <div className="billing-form">
                                <div className="address ">
                                    <div className='max-h-[40vh] min-h-[40vh] overflow-y-scroll overflow-x-hidden  '>
                                        {addressValues?.address?.map((el, id) => (
                                            <div className="singleAddress" key={id}>
                                                <div style={{ display: "flex" }}>
                                                    <input
                                                        className="btn-radio"
                                                        type="radio"
                                                        value={el._id}
                                                        checked={addressValues.shippingAddress == el._id}
                                                        name="rd"
                                                        style={{ marginRight: "5px" }}
                                                        onChange={(e) => {
                                                            setAddressValues({
                                                                ...addressValues,
                                                                shippingAddress: el._id,
                                                                addressline1: el.addressLineOne,
                                                                addressline2: el.addressLineTwo,
                                                                city: el.city,
                                                                country: el.country,
                                                                state: el.state,
                                                                zipCode: el.postalCode,
                                                                firstName: el.firstName,
                                                                lastName: el.lastName,
                                                            });
                                                        }}
                                                    />
                                                    <div className="address">
                                                        <div className="name">
                                                            {el?.firstName} {el?.lastName || ""}
                                                        </div>
                                                        <div className="add">
                                                            {el?.addressLineOne} {el?.addressLineTwo} {el?.city}{" "}
                                                            {el?.state} {el.postalCode} {el.country}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="buttons">
                                                    <div className="edit" onClick={() => editHandler(id)}>
                                                        Edit
                                                    </div>
                                                    |
                                                    <div className="delete" onClick={() => deleteData(id)}>
                                                        Delete
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="allAddress">
                                        <div className="link"></div>
                                        {addressValues?.address?.length >= 5 ? (
                                            <div
                                                className="addNew"
                                                style={{ cursor: "auto", opacity: "0.5" }}
                                            >
                                                + Add New Address
                                            </div>
                                        ) : (
                                            <div className="addNew" onClick={addNewHandler}>
                                                + Add New Address
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h6 className="my-2">Select billing address  </h6>
                            <div className="billing-form">
                                <div className="address ">
                                    <div className='max-h-[40vh] min-h-[40vh] overflow-y-scroll overflow-x-hidden  '>
                                        {billingAddressValue?.map((el, id) => (
                                            <div className="singleAddress" key={id}>
                                                <div style={{ display: "flex" }}>
                                                    <input
                                                        className="btn-radio"
                                                        type="radio"
                                                        value={el._id}
                                                        checked={addressValues.billingAddress == el._id}
                                                        name="billing"
                                                        style={{ marginRight: "5px" }}
                                                        onChange={(e) => {
                                                            setAddressValues({
                                                                ...addressValues,
                                                                billingAddress: el._id,

                                                            });
                                                        }}
                                                    />
                                                    <div className="address">
                                                        <div className="name">
                                                            {el?.firstName} {el?.lastName || ""}
                                                        </div>
                                                        <div className="add">
                                                            {el?.addressLineOne} {el?.addressLineTwo} {el?.city}{" "}
                                                            {el?.state} {el.postalCode} {el.country}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="buttons">
                                                    <div className="edit" onClick={() => handleEditBillingAddress(el._id)}>
                                                        Edit
                                                    </div>
                                                    |
                                                    <div className="delete" onClick={() => deleteBilllingAddress(el._id)}>
                                                        Delete
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="allAddress">
                                        <div className="link"></div>
                                        {billingAddressValue?.length >= 5 ? (
                                            <div
                                                className="addNew"
                                                style={{ cursor: "auto", opacity: "0.5" }}
                                            >
                                                + Add New Address
                                            </div>
                                        ) : (
                                            <div className="addNew" onClick={addNewBillingAddress}>
                                                + Add New Address
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {!isQuoteDownloading ? <button onClick={handleDownload} className="primary-btn">
                        Download Quotation
                    </button> : <button className="primary-btn">
                        <LucidLoader />
                    </button>}

                    {/* 
                    <Button
                        onClick={() => setShow(false)}
                        className="req-quote-btn"
                    >
                        Close
                    </Button> */}
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DownloadQuotationModal